import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './TilList.css';
import Loading from '../../common/Loading';

function TilList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('https://api.mutantbutton2.com/public/til')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch TIL posts');
        }
        return response.json();
      })
      .then(data => {
        setPosts(data.posts || []);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching TIL posts:', error);
        setError(error.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="til-list"><Loading /></div>;
  }

  if (error) {
    return <div className="til-list error">Error: {error}</div>;
  }

  return (
    <div className="til-list">
      <nav className="breadcrumb">
        <NavLink to="/">Home</NavLink>
        <span className="separator">></span>
        <span className="current">TIL</span>
      </nav>
      
      <h1>Today I Learnt</h1>
      {posts.length === 0 ? (
        <p className="no-posts">No posts available yet.</p>
      ) : (
        <div className="til-grid">
          {posts.map((post, index) => {
            const imageUrl = post.images && post.images.length > 0 
              ? `https://raw.githubusercontent.com/mutantbutton2/todayilearnt/main/content/${post.date}/${post.images[0]}`
              : null;
            
            return (
              <NavLink
                key={index}
                to={`/til/${post.date}`}
                className="til-card"
              >
                {imageUrl && (
                  <div className="til-card-image">
                    <img src={imageUrl} alt={post.title} />
                  </div>
                )}
                <div className="til-card-content">
                  <div className="til-card-date">{post.date}</div>
                  <h3 className="til-card-title">{post.title}</h3>
                  {post.description && (
                    <p className="til-card-description">{post.description}</p>
                  )}
                </div>
              </NavLink>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default TilList;
